import { Button, Col, Descriptions, Input, Row, Select } from 'antd';
import { HL7resourcesAll } from '../../../consts';
import PropTypes from 'prop-types';
import React from 'react';

const { Option } = Select;

class ConfirmWithoutTemplates extends React.Component {
  static propTypes = {
    addFile: PropTypes.func.isRequired,
    fileSchemaName: PropTypes.string.isRequired,
  };

  state = {
    namespace: '',
    resourceType: '',
  };

  onChangeResourceType = e => {
    this.setState({ resourceType: e });
  };

  onChangeNamespace = e => {
    this.setState({ namespace: e.target.value });
  };

  render() {
    const { resourceType, namespace } = this.state;
    const { fileSchemaName } = this.props;
    return (
      <>
        <Row>
          <Col>
            <Descriptions style={{ marginTop: 20, marginBottom: 20 }} bordered column={1}>
              <Descriptions.Item label="File Schema Name">{fileSchemaName}</Descriptions.Item>
            </Descriptions>
          </Col>
        </Row>
        <Row>
          <Col span={8}>
            ResourceType:{' '}
            <Select
              placeholder="Patient"
              data-cy="resourcetype-select"
              style={{ width: 250 }}
              onChange={this.onChangeResourceType}
            >
              {HL7resourcesAll.map(option => {
                return (
                  <Option data-cy={`resourcetype-option-${option}`} value={option}>
                    {option}
                  </Option>
                );
              })}
            </Select>
          </Col>
        </Row>
        <br />
        <Row>
          <Col span={8}>
            Namespace:{' '}
            <Input
              data-cy="namespace-input"
              onChange={this.onChangeNamespace}
              placeholder="default"
              style={{ width: 250 }}
            />
            <br />
            <Button
              style={{ marginTop: 20 }}
              type="primary"
              onClick={() => this.props.addFile(resourceType, namespace)}
            >
              Confirm
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}

export default ConfirmWithoutTemplates;
